export default __webpack_public_path__ + "static/media/close.437d17c3.svg";